const prefix = 'FACILITY_PAYMENT_DEPOSIT';
export const SET_POPUP_DATA = `${prefix}_SET_POPUP_DATA`;
export const GET_PARTNERS = `${prefix}_GET_PARTNERS`;
export const SET_PARTNERS = `${prefix}_SET_PARTNERS`;
export const SET_PARTNER = `${prefix}_SET_PARTNER`;
export const SET_PROGRAM_TYPE = `${prefix}_SET_PROGRAM_TYPE`;
export const SET_PROGRAM_PAYMENT_TYPE = `${prefix}_SET_PROGRAM_PAYMENT_TYPE`;
export const SEND_PAYMENT_DEPOSIT = `${prefix}_SEND`;
export const DOWNLOAD_PAYMENT_DEPOSIT = `${prefix}_DOWNLOAD`;
export const CHECK_FACILITY_DEPOSIT = `${prefix}_CHECK`;